import {trim} from '@/utils/base';
import {getCss} from '@/utils/dom';

/**
 * 获取表格列最大宽度
 *
 * @prop {*} opt.key 字段名
 * @prop {*} opt.data 表格数据
 * @prop {*} opt.initText 表格列头标题
 * @prop {*} opt.maxInitTextLength 表格列头默认标题最大允许字
 * @prop {*} opt.extraWidth 额外的宽度(常用于内边距)
 * @prop {*} opt.childrenField 树形数据的子代字段名
 * @prop {*} opt.font 字体样式
 * @prop {*} opt.sortable 是否有排序
 * @prop {*} opt.fold 是否有折叠
 * @prop {*} opt.minWidth 指定最小宽度
 * @prop {*} opt.maxWidth 指定最大宽度
 * @prop {*} allowMaxWidthObj 最大允许宽度对象
 *
 */
 export function getMaxColumnWidth(opt = {}, allowMaxWidthObj={}) {
  // console.log(opt);
  const {
    data, //数据
    key,
    initText = '留四个字留四个字留四个字留四个字留四个字',
    maxInitTextLength = 5,
    extraWidth = 20,
    childrenField = 'children'
  } = opt;
  if (key.includes('__placeholder__')) return undefined;

  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  
  // 获取表头文本最大宽度
  // ctx.font = "14px Microsoft YaHei";
  // ctx.font = opt.font || "14px Avenir, Helvetica, Arial, sans-serif";
  ctx.font = opt.font || "14px Avenir, Helvetica, Arial, sans-serif";
  let result = ctx.measureText(initText.slice(0, maxInitTextLength)).width;
  if (opt.sortable) result += 25;
  if (opt.fold) result += 40;
  // console.log(initText, result);
  
  // 获取数据文本最大宽度
  function getArrayMaxWidth(arr) {
    if (Array.isArray(arr)) {
      arr.forEach((item) => {
        const text = item[key] ? item[key] + '' : '';
        const textW = ctx.measureText(text).width;
        if (result < textW) result = textW;
        getArrayMaxWidth(item[childrenField]);
      });
    }
  }
  getArrayMaxWidth(data);
  result = Math.ceil(result) + 10 + extraWidth;

  // 指定最大宽度
  const maxW = allowMaxWidthObj[key] || opt.maxWidth;
  if (maxW && result > maxW) result = maxW;

  // 指定最小宽度
  if (opt.minWidth && result < opt.minWidth) result = Number(opt.minWidth);
  
  return result;
}

// 使用示例
// const data = [
//   {id: 1, title: '张三'},
//   {id: 2, title: '三大发发撒打发2'},
//   {id: 3, title: '阿斯顿发啊', children: [{id: '3-1', title: '额发二无群若无热无若'}]},
// ];

// getMaxColumnWidth({key: 'title', data, initText: '我是标题'});


/**
 * 获取列表表格最大高度
 * @param {*} opt.selectorContainer 容器类名
 * @param {*} opt.reduceSelectors 要减去的容器类名集合
 * @param {*} opt.reduceHeight 要减去的高度
 * @returns 表格高度
 */
export function getMainTableMaxHeight(opt={}){
  const {
    selectorContainer = '.mainContainer',  //容器选择器
    reduceSelectors = ['.main-filter-container', '.main-tip', '.main-table-pagination', '.main-tabbar'], //减去的选择器
    reduceHeight = 85,
  } = opt;
  
  const eleContainers = document.querySelectorAll(selectorContainer);
  const eleContainer = eleContainers[eleContainers.length -1];
  let maxH = eleContainer.offsetHeight;

  if (Array.isArray(reduceSelectors) && reduceSelectors.length > 0){
    reduceSelectors.forEach(selector => {
      const eles = eleContainer.querySelectorAll(selector);

      if (!(eles.length > 0)) return;
      const ele = eles[eles.length - 1];
      if (!ele) return;

      const h = ele ? ele.offsetHeight : 0;
      const marginTop = getCss(ele, 'marginTop');
      // console.log(2, ele, maxH, h, marginTop);
      maxH -= (h + marginTop);
    })
  }

  return maxH - reduceHeight + "px";
}

/**
 * 自定义下拉框搜索方法（非远程搜索）
 * 本地请求全部数据后，前端搜索
 *
 * @param {*} ctx 上下文
 * @param {*} opt/optionsField 上下文中完整的选项列表字段名
 * @param {*} opt/filterOptionsField 上下文中筛选后的选项列表字段名
 * @param {*} opt/valueField value的字段名
 * @param {*} opt/labelField label的字段名
 * @param {*} value 搜索值
 */
export function selectfilterMethod(ctx, opt=[], value){
  const [optionsField, filterOptionsField, valueField, labelField] = opt;
  const list = ctx[optionsField];
  const trimValue = trim(value);
  // 真正的搜索项字段名
  const reallLabelField = labelField ? labelField : valueField;

  // 无数据或者搜索项为空时，置空下拉选项
  if (!(Array.isArray(list) && list.length > 0) || trimValue === ''){
    ctx[filterOptionsField] = undefined;
    return;
  }

  // 筛选出命中的搜索项集合
  ctx[filterOptionsField] = list
    .filter(item => item[reallLabelField].includes(trimValue))
    .map(item => ({
      id: item.id,
      value: item[valueField],
      label: item[reallLabelField],
    }));
}



/** 拖拽
 *
 * @param {HTMLElement} option.container 拖动容器dom
 * @param {String} option.elementClass 拖动、放置元素类名
 * @param {String} option.handleClass 拖动源类名
 * @param {Function} option.onMove 自定义拖拽排序回调，回传参数：拖拽元素索引、放置元素索引
 *
 */
export function startDrag(option={}){
  const {container, elementClass='hn-drag-item', handleClass, onMove } = option;
  let dragDom;  //拖拽元素
  let canDrag = true;  //是否允许拖拽

  container.onmousedown = ev => {
    const {target} = ev;

    // 如果指定了拖拽源，但找不到拖拽源，直接结束，不允许拖动
    if (handleClass){
      // 获取拖拽源元素
      let dragOriginDom = target;
      while (dragOriginDom !== container && !dragOriginDom.classList.contains(handleClass)){
        dragOriginDom = dragOriginDom.parentNode;
      }

      if (dragOriginDom === container){
        canDrag = false;
        return;
      }
    }

    // 获取拖拽元素
    let dragDom = target;
    while (dragDom !== container && !dragDom.classList.contains(elementClass)){
      dragDom = dragDom.parentNode;
    }

    // 鼠标点击拖拽源时，给拖拽元素添加拖拽属性
    if (dragDom.classList.contains(elementClass)) dragDom.draggable = true;
  }

  container.ondragstart = ev => {
    const {target} = ev;
    if (!canDrag) return;

    // 获取拖拽元素
    dragDom = target;
    while (dragDom !== container && !dragDom.classList.contains(elementClass)){
      dragDom = dragDom.parentNode;
    }

    // 保证在拖拽的刹那，不改变拖拽元素的样式，等拖拽起来后，再异步给元素添加样式。
    // 这样不会影响鼠标拖拽元素的样式。
    setTimeout(() => {dragDom.classList.add('dragging');}, 0);

    ev.dataTransfer.effectAllowed = 'move'; //改动鼠标拖动指针样式，去掉加号
  }

  container.ondragover = ev => {ev.preventDefault();}

  container.ondragenter = (ev) => {
    ev.preventDefault();
    const {target} = ev;
    if (!canDrag) return;
    if (!dragDom) return;

    // 获取放置元素
    let dropDom = target;
    while (dropDom !== container && !dropDom.classList.contains(elementClass)){
      dropDom = dropDom.parentNode;
    }

    // 如果放置源等于容器或者拖拽源，直接结束
    if (dropDom === container || dropDom === dragDom) return;

    // const dragIndex = dragDom.dataset.index; //拖动元素索引
    // const dropIndex = dropDom.dataset.index; //放置元素索引
    const dragIndex = getIndex(dragDom); //拖动元素索引
    const dropIndex = getIndex(dropDom); //放置元素索引
    if (dragIndex !== dropIndex) onMove(dragIndex, dropIndex);
  }

  container.onmouseup = () => {reset()};
  container.ondragend = () => {reset()};

  // 重置
  function reset(){
    container.querySelectorAll(`.${elementClass}`).forEach(item => {
      item.classList.remove('dragging');
      item.draggable = false;
    })
    dragDom = null;
    canDrag = true;
  }

  // 获取当前同类元素的索引
  function getIndex(element) {
    const parent = element.parentNode;
    const result = [...parent.children].filter(child => child.classList.contains(elementClass))
    return result.indexOf(element);
  }
}

export function getRandomString5(num) {

    const nonDigitChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    // 确保第一个字符不是数字
    let result = nonDigitChars.charAt(Math.floor(Math.random() * nonDigitChars.length));
    return result + Math.random().toString(36).substr(2, num - 1);
}
export function getXTSessionid(){
    const xtSessionid = sessionStorage.getItem("x-t-sessionid");
    if (![undefined, null, '', 'null', 'undefined'].includes(xtSessionid)) return xtSessionid;

    const nextXtSessionid = new Date().getTime() + "_" + Math.random().toString().substring(3, 8);
    sessionStorage.setItem("x-t-sessionid",  nextXtSessionid);
    return nextXtSessionid;
}


// 获取用户信息
export function getUserInfo(){
  let userInfo = localStorage.getItem('userInfo');
  try {
    if (userInfo){
      userInfo = JSON.parse(userInfo);
      return userInfo || {};
    }
  } catch(err){
    console.err(err);
  }
  return {};
}